// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"1aed1fc2","66":"c38be34b","453":"5c16539a","532":"1be3ac55","593":"a7585de8","772":"36b47494","786":"b4e1f36e","855":"f1e5facd","895":"c7bebd3f","914":"037836b0"}[chunkId] + ".chunk.js";
};